/* app/js/src/components/scheduler/filter/filter.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-corner {
  background: transparent;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  position: absolute;
  left: 0;
  width: 300px;
  z-index: 4;
  height: 100%;
  background-color: #eef2f6;
  max-height: 100vh;
  overflow: visible;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
  box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0);
}
:host.visible {
  -webkit-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.2);
}
:host.isHidden {
  display: none;
}
.search-wrapper {
  height: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.search-wrapper .media-search-filter {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.search-wrapper .media-search-filter .sort-by-wrapper {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.search-wrapper .media-search-filter .graphics-filter {
  background-color: white;
  padding-left: 38px;
}
.search-wrapper .media-search-filter .filter-by-wrapper {
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.search-wrapper .media-search-filter .filter-by-wrapper .filter-by-options {
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 30px;
  padding-bottom: 30px;
  background-color: white;
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
}
.search-wrapper .media-search-filter .filter-by-wrapper .date-created-container > div > label,
.search-wrapper .media-search-filter .filter-by-wrapper .license-container > div > label {
  color: #7d8fa1;
  text-transform: uppercase;
  font-size: 0.7em;
  min-width: 35px;
  display: inline-block;
}
.search-wrapper .title-wrapper {
  background-color: #eef2f6;
  padding: 23px 10px 23px 33px;
  max-height: 1em;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.search-wrapper .title-wrapper i {
  display: inline;
  float: right;
  margin-right: 5px;
}
.search-wrapper .title-wrapper i svg {
  fill: #879baf;
}
i {
  cursor: pointer;
}
.descending-sort-media {
  transform: scale(1, -1);
}
.descending-sort-graphics {
  transform: scale(1, -1);
}
.filterLabel,
.search-wrapper .title-wrapper span {
  color: #232f3a;
  font-size: 0.8em;
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  letter-spacing: 0.1px;
  text-transform: uppercase;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clear-all-filters {
  float: right;
  text-decoration: underline;
  font-weight: normal;
  margin-right: 5px;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.icn-radio-button {
  padding-top: 23px;
  padding-left: 38px;
  padding-bottom: 23px;
  background-color: white;
}
.icn-radio-button .radio-separator {
  height: 7px;
}
.icn-radio-button2 {
  padding-top: 5px;
  padding-left: 15px;
  padding-bottom: 0px;
}
.filter-option-header {
  font-size: 12px;
  font-family: "OpenSans";
  color: #7d8fa1;
  padding-top: 25px;
  margin-bottom: 5px;
  display: block;
}
dateinput {
  display: inline-block;
  position: relative;
  margin-top: 5px;
  margin-right: 5px;
}
.countries-container {
  margin-top: 12px;
}
.tag-list-container,
.asset-type-list-container,
.languages-list-container,
.countries-list-container,
.templates-list-container {
  padding-left: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
.tag-list-container li,
.asset-type-list-container li,
.languages-list-container li,
.countries-list-container li,
.templates-list-container li {
  margin: 7px 8px 6px 0px;
}
.tag-list-container .more-tags label,
.asset-type-list-container .more-tags label,
.languages-list-container .more-tags label,
.countries-list-container .more-tags label,
.templates-list-container .more-tags label {
  padding-top: 8px;
  padding-bottom: 8px;
  height: 26px;
  line-height: 0;
}
.tag-list-container .more-tags input + label::after,
.asset-type-list-container .more-tags input + label::after,
.languages-list-container .more-tags input + label::after,
.countries-list-container .more-tags input + label::after,
.templates-list-container .more-tags input + label::after {
  font-family: "OpenSans";
  content: "...";
  color: #879baf;
  font-size: 20px;
  line-height: 0;
}
.tag-list-container .more-tags:hover label,
.asset-type-list-container .more-tags:hover label,
.languages-list-container .more-tags:hover label,
.countries-list-container .more-tags:hover label,
.templates-list-container .more-tags:hover label {
  background-color: #40c4ff;
}
.tag-list-container .more-tags:hover input + label::after,
.asset-type-list-container .more-tags:hover input + label::after,
.languages-list-container .more-tags:hover input + label::after,
.countries-list-container .more-tags:hover input + label::after,
.templates-list-container .more-tags:hover input + label::after {
  color: white;
}
.tag-list-container .less-tags label,
.asset-type-list-container .less-tags label,
.languages-list-container .less-tags label,
.countries-list-container .less-tags label,
.templates-list-container .less-tags label {
  padding-bottom: 0px;
}
.tag-list-container .less-tags input + label::after,
.asset-type-list-container .less-tags input + label::after,
.languages-list-container .less-tags input + label::after,
.countries-list-container .less-tags input + label::after,
.templates-list-container .less-tags input + label::after {
  font-family: "OpenSans";
  content: "^";
  color: #879baf;
  font-size: 20px;
  line-height: 17px;
}
.tag-list-container .less-tags:hover label,
.asset-type-list-container .less-tags:hover label,
.languages-list-container .less-tags:hover label,
.countries-list-container .less-tags:hover label,
.templates-list-container .less-tags:hover label {
  background-color: #40c4ff;
}
.tag-list-container .less-tags:hover input + label::after,
.asset-type-list-container .less-tags:hover input + label::after,
.languages-list-container .less-tags:hover input + label::after,
.countries-list-container .less-tags:hover input + label::after,
.templates-list-container .less-tags:hover input + label::after {
  color: white;
}
.tag-list-container .input-hidden,
.asset-type-list-container .input-hidden,
.languages-list-container .input-hidden,
.countries-list-container .input-hidden,
.templates-list-container .input-hidden {
  display: none;
}
.tag-list-container label,
.asset-type-list-container label,
.languages-list-container label,
.countries-list-container label,
.templates-list-container label {
  color: #879baf;
  border: 1px solid #dde3e7;
  font-family: "OpenSans";
  font-size: 12px;
  border-radius: 4px;
  padding: 5px 12px 5px 12px;
  display: inline-block;
}
.tag-list-container label:hover,
.asset-type-list-container label:hover,
.languages-list-container label:hover,
.countries-list-container label:hover,
.templates-list-container label:hover {
  cursor: pointer;
}
.tag-list-container input:checked + label,
.asset-type-list-container input:checked + label,
.languages-list-container input:checked + label,
.countries-list-container input:checked + label,
.templates-list-container input:checked + label {
  border-color: #40c4ff;
  color: #232f3a;
}
.display-none {
  display: none;
}
.templates-list-container .more-tags:hover label {
  background-color: #a65bfa;
}
.templates-list-container .less-tags:hover label {
  background-color: #a65bfa;
}
.templates-list-container input:checked + label {
  border-color: #a65bfa;
  color: #232f3a;
}
/*# sourceMappingURL=filter.component.css.map */
